import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "../i18n";

const FAQAccordion = ({ items, limit }) => {
    const { t } = useLang();
    const [openIdx, setOpenIdx] = useState(0);
    const base = items || t.faqs;
    const list = limit ? base.slice(0, limit) : base;

    return (
        <div data-testid="faq-accordion" className="mt-10 divide-y divide-[#E3DCCF] rounded-[1.5rem] border border-[#E3DCCF] bg-white">
            {list.map((item, i) => {
                const open = openIdx === i;
                return (
                    <div key={i}>
                        <button
                            data-testid={`faq-question-${i + 1}`}
                            onClick={() => setOpenIdx(open ? -1 : i)}
                            aria-expanded={open}
                            className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors hover:bg-cream/60"
                        >
                            <span className={`font-serif text-lg font-semibold sm:text-xl ${open ? "text-terracotta" : "text-ink"}`}>
                                {item.q}
                            </span>
                            <motion.span
                                animate={{ rotate: open ? 45 : 0 }}
                                transition={{ duration: 0.25 }}
                                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border ${open ? "border-terracotta bg-terracotta text-cream" : "border-[#E3DCCF] text-[#525B53]"}`}
                            >
                                <Plus size={15} />
                            </motion.span>
                        </button>
                        <AnimatePresence initial={false}>
                            {open && (
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={{ height: "auto", opacity: 1 }}
                                    exit={{ height: 0, opacity: 0 }}
                                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                                    className="overflow-hidden"
                                >
                                    <p className="px-6 pb-6 text-[15px] leading-relaxed text-[#525B53]">
                                        {item.a}
                                    </p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                );
            })}
        </div>
    );
};

export default FAQAccordion;
